import styled from 'styled-components';
import { GeneralTitleDefaultBox } from './general-title.default.box';

export const GeneralTitleCasinoSIBox = styled(GeneralTitleDefaultBox)`
    flex-grow: 100;
    border-radius: 3px 0px 0px 3px;
    border-left: 5px solid ${props => props.theme.colors.brandPrimary};
`;